import './App.css';
import { useEffect, useState, Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import { OrbitControls, Stats, Loader } from "@react-three/drei"
// import { Physics} from '@react-three/cannon';
import { Physics, PhysicsStats } from 'use-ammojs'
import * as THREE from "three"

//Components
import HtmlOverlay from "./Components/HtmlOverlay/HtmlOverlay"
import Firstpersonprespective from "./Components/Player/Firstpersonprespective"
import FPSNew from './Components/Player/FPSNew'
import Lights from "./Components/Lights/Lights"
import StallPlacement from './Components/Hall/Stalls/StallPlacement';
// import  {Loader}  from './Components/Loader/Loader';
import HotspotBtns from './Components/HtmlOverlay/HotspotBtns';
import Video from './Components/Loader/Video';
import StallNavigation from './Components/HtmlOverlay/StallNavigation';
import Dummy from "./Components/Player/Dummy"

function App() {

  const [stallData, setStallData] = useState([])
  const [types, setTypes] = useState([])
  const [hotspot, setHotspot] = useState([])
  const [sponsors, setSponsors] = useState([])

  const getStallData = async () => {
    // const response = await fetch("https://boring-goldberg-0ae08e.netlify.app/Json_JITOEvent.json")
    const response = await fetch("/data.json")
    const data = await response.json()
    setHotspot(data.data.hall.hotspots_data)
    setSponsors(data.data.hall.sponsors)
    setStallData(data.data.stall)
  }

  useEffect(() => {
    getStallData()
  }, [])

  // const f = () => <Physics></Physics>

  // console.log(f())

  useEffect(() => {
    const rows = []
    stallData.forEach((stall, index) => {
      if (stallData.length % 2 === 0) {
        if (index % 2 === 0) {
          const coloumn = [stall.stall_type, stallData[index + 1].stall_type]
          rows.push(coloumn)
        }
      } else {
        if (index === stallData.length - 1) {
          if (index % 2 === 0) {
            const coloumn = [stall.stall_type, "null"]
            rows.push(coloumn)
          }
        } else {
          if (index % 2 === 0) {
            const coloumn = [stall.stall_type, stallData[index + 1].stall_type]
            rows.push(coloumn)
          }
        }
      }
    })
    setTypes(rows)


  }, [stallData])

  useEffect(() => {

  }, [types])


  return (
    <>
      {types.length > 0 ? (
        <>

          <Canvas
            shadows
            gl={{ alpha: false, antialias: true }}
            camera={{ fov: 45, position: [-400, 20, -50], near: 0.1, far: 2000 }}
            onCreated={({ gl }) => {
              gl.physicallyCorrectLights = true;
              gl.outputEncoding = THREE.sRGBEncoding
              // gl.gammaOutput = true;
              gl.gammaFactor = 2.2;
              gl.toneMapping = THREE.LinearToneMapping
              gl.toneMappingExposure = 2
            }}
            dpr={Math.min(2, window.devicePixelRatio)}
          >
            <Lights />
            <axesHelper position={[0, 30, 0]} scale={[60, 60, 60]} />

            <Physics fixedTimeStep={1/120} >
              <Suspense fallback={null}>
                <StallPlacement
                  stallData={stallData}
                  types={types}
                  hotspotData={hotspot}
                  sponsorsData={sponsors}
                />
              </Suspense>
              {/* <FPSNew/> */}
              {/* <Firstpersonprespective/> */}


              <PhysicsStats top={48} />
            </Physics>
            <Video />
            {/* <OrbitControls/> */}
          </Canvas>
          <HtmlOverlay />
          <HotspotBtns />
          <StallNavigation />
          <Stats />
          <Loader />
        </>
      ) : (
        <h1>Loading</h1>
      )}


    </>
  );
}

export default App;
